<template>
  <div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          {{ isDentalLaboratory ? '기공소' : '제조사' }} 계정 관리
        </h3>
        <span class="pageDesc">
          {{ isDentalLaboratory ? '기공소' : '제조사' }} 페이지에 접속한 계정을 조회하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center;">
        <button
          class="btn btn-primary"
          type="button"
          @click="downloadExcel()"
        >
          엑셀 내려받기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox"/>
      <div class="searchinputbox">
        <select v-model="searchFilter" 
        id="itemCode"
        >
          <option value="" selected>선택</option>
          <option value="corpName">{{ isDentalLaboratory ? '기공소명' : '제조사명' }}</option>
          <option value="name">관리자명</option>
          <option value="username">관리자 이메일</option>
          <option value="duty">직급</option>
          <option value="deptName">부서</option>
          <option value="parentDeptName">상위부서</option>
        </select>
          <input 
          type="text" 
          placeholder="조건을 입력해주세요." 
          v-model="condition" 
          ref="cdInput"
          id=""
          autocomplete="off"
          @keyup.enter="enter()"
          :readonly="!isFocused"
          @focus="isFocused = true"
          />
          <div class="searchBtn">
            <img 
            src="../../assets/img/search.png"
            alt="search"
            class="hoverPointer"
            @click="enter()"
            />
          </div>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select class="search-select" v-model="rowsPerPage" @change="handleRowsPerPage">
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table 
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
        @change="handleTableChange"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination 
        :page-info="paginationData"
        page-name="CertificateList"
        @change-page="paginationHandler"
      />
    </div>
    <!-- <div class="py-4 container-fluid card" style="width: 98%; margin: 1vw">
      <div class="kdh_table_div table-responsive p-0">
        <div v-if="responseData.length === 0" class="noResult">검색 결과가 없습니다.</div>
        <table v-else class="kdh_table table align-items-center mb-0">
          <colgroup>
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
          </colgroup>
          <thead>
            <th class="text-uppercase text-secondary font-weight-bolder">
              제조사명
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              관리자명
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              관리자 ID
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              IP
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              접속 기기
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              최근 접속 시간
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              최초 접속 시간
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              비밀번호
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              관리
            </th>
          </thead>
          <tbody>
            <tr scope="row" v-for="(item, i) in responseData" :key="i">
              <td>{{ item.corpName }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.ip || '-' }}</td>
              <td>{{ item.agent || '-' }}</td>
              <td>{{ convertDate(item.lastLoginAt) }}</td>
              <td>{{ convertDate(item.firstLoginAt) }}</td>
              <td style="padding: 0.7vw">
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#resetyesno"
                  @click="selectManufacturer(item)"
                >
                  초기화
                </button>
              </td>
              <td style="padding: 0.7vw">
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#logoutyesno"
                  @click="selectManufacturer(item)"
                >
                  연결해제
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <!-- 삭제 모달 -->
    <div
      class="modal fade"
      id="logoutyesno"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>계정 연결 해제</h4>
              <h6>해당 계정을 로그아웃 처리하시겠습니까?</h6>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 2rem">
              <button
                style="margin-right: 1vw;"
                type="button"
                class="btn btn-primary"
                @click="logoutUser()"
                >
                연결 해제
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
              취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 초기화 모달 -->
    <div
      class="modal fade"
      id="resetyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>비밀번호 초기화</h4>
              <h6>임시 비밀번호는 관리자 ID와 동일합니다.</h6>
              <h6>초기화하시겠습니까?</h6>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 2rem">
              <button
                style="margin-right: 1vw;"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
              취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                data-bs-dismiss="modal"
                @click="resetPassword()"
              >
              초기화
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <menu-manage-modal
    :show-modal="isModalOpen"
    @close-modal="closeMenuManageModal"
    :username="selectedUser"
  />
  
  <!-- 권한 범위 미리보기 모달 (SPEC-CONTRACT-CENTER-AUTH-001 R7) -->
  <!-- @MX:NOTE: [AUTO] 운영자 전용 visible-depts 모달 — 비운영자 호출 시 백엔드 403, 비인증 401 반환 -->
  <a-modal
    v-model:visible="visibleDeptsModalVisible"
    :footer="null"
    @cancel="closeVisibleDeptsModal"
    width="500px"
  >
    <template #title>
      <div class="modal-title">권한 범위 미리보기</div>
    </template>

    <div class="modal-content">
      <!-- 로딩 상태 -->
      <div v-if="visibleDeptsLoading" style="text-align: center; padding: 24px 0;">
        <a-spin />
      </div>

      <!-- 에러 상태 -->
      <div v-else-if="visibleDeptsError" style="text-align: center; color: #ff4d4f; padding: 16px 0;">
        <p>{{ visibleDeptsError }}</p>
      </div>

      <!-- 정상 응답 -->
      <div v-else-if="visibleDeptsData">
        <a-descriptions :column="1" bordered size="small" style="margin-bottom: 16px;">
          <a-descriptions-item label="관리자 ID">{{ visibleDeptsData.username }}</a-descriptions-item>
          <a-descriptions-item label="직급">{{ visibleDeptsData.duty || '-' }}</a-descriptions-item>
          <a-descriptions-item label="부서">{{ visibleDeptsData.deptName || '-' }}</a-descriptions-item>
        </a-descriptions>

        <div style="margin-top: 16px;">
          <div style="font-weight: 600; margin-bottom: 8px; font-size: 14px;">조회 가능한 부서 목록</div>
          <div v-if="!visibleDeptsData.visibleDepts || visibleDeptsData.visibleDepts.length === 0">
            <a-tag color="orange">본인 작성분만 조회 가능</a-tag>
          </div>
          <div v-else-if="visibleDeptsData.visibleDepts.includes('*')">
            <a-tag color="blue">전체 계약 조회 가능 (마스터)</a-tag>
          </div>
          <div v-else>
            <a-tag
              v-for="dept in visibleDeptsData.visibleDepts"
              :key="dept"
              style="margin: 4px 4px 4px 0;"
            >{{ dept }}</a-tag>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <a-button @click="closeVisibleDeptsModal">닫기</a-button>
      </div>
    </div>
  </a-modal>

  <!-- 관리자 계정 수정 모달 -->
  <a-modal
    v-model:visible="editModalVisible"
    :confirm-loading="editLoading"
    :footer="null"
    @cancel="cancelEdit"
  >
    <template #title>
      <div class="modal-title">관리자 계정 수정</div>
    </template>
    
    <div class="modal-content">
      <a-form layout="vertical" :model="formEdit" ref="editForm">
        <a-form-item 
          label="새 관리자 ID" 
          name="username"
          :rules="[{ required: true, message: '새로운 관리자 ID를 입력하세요' }]"
        >
          <a-input 
            v-model:value="formEdit.username" 
            placeholder="새로운 관리자 ID를 입력하세요"
            @change="handleUsernameChange"
          />
        </a-form-item>

        <a-divider />
        
        <!-- 비밀번호 변경 섹션 -->
        <div class="password-section">
          <h4 style="margin-bottom: 16px; font-size: 14px; font-weight: 600;">비밀번호 변경</h4>
          
          <a-form-item 
            label="새 비밀번호" 
            name="newPassword"
          >
            <a-input-password 
              v-model:value="formEdit.newPassword" 
              placeholder="새 비밀번호를 입력하세요 (선택사항)"
              @change="handlePasswordChange"
            />
            <div v-if="formEdit.newPassword" class="password-hint">
              <small style="color: #666;">
                • 8자 이상 입력하세요<br/>
                • 영문, 숫자, 특수문자를 포함하세요
              </small>
            </div>
          </a-form-item>
          
          <a-form-item 
            v-if="formEdit.newPassword"
            label="비밀번호 확인" 
            name="confirmPassword"
          >
            <a-input-password 
              v-model:value="formEdit.confirmPassword" 
              placeholder="비밀번호를 다시 입력하세요"
              @change="handlePasswordChange"
            />
            <div v-if="formEdit.confirmPassword && formEdit.newPassword !== formEdit.confirmPassword" 
                 class="password-error">
              <small style="color: #ff4d4f;">비밀번호가 일치하지 않습니다</small>
            </div>
          </a-form-item>
        </div>
      </a-form>
      
      <div class="modal-footer">
        <a-button @click="cancelEdit">취소</a-button>
        <a-button 
          type="primary" 
          @click="confirmEdit" 
          :loading="editLoading"
          :disabled="!isFormValid"
          class="yellow-button"
        >확인</a-button>
      </div>
    </div>
  </a-modal>

  <!-- 2차 인증 창(상태·예외·잠금·초기화·이력, REQ-ACC-012) -->
  <account-security-modal :account="securityAccount" @close="securityAccount = null" />
</template>
<script>
import { 
  convertDate, 
  openDialog,
  convertDateTime,
 } from "@/utils/utils";
import Pagination from "@/views/components/Pagination.vue";
import MenuManageModal from '@/views/MenuManageModal.vue';
import AccountSecurityModal from "@/views/components/AccountSecurityModal.vue";
import dayjs from "dayjs";
import { isSupportRow, supportBadge } from "@/utils/accountRows";

export default {
  name: "manuAccManage",
  components: {
    Pagination,
    MenuManageModal,
    AccountSecurityModal,
  },
  data() {
    return {
      convertDateTime,
      // type은 computed에서 동적으로 결정

      // 목록 받아오는 변수
      responseData: [], 
   

      
      selectedManufacturer: {}, // 선택한 제조사 정보
      isFocused: false, // 자동완성 때문에 최초엔 폴스로
      
      searchFilter: "", // 필터 종류
      condition: "", // 검색어
      sort: { //소트
            parameter: 'lastLoginAt',
            method: 'DESC'
      },
      selectedUser: '',
      isModalOpen: false,
      securityAccount: null, // 「2차 인증」 창을 연 행

      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      columns: [
        { key: 'corpName', title: this.isDentalLaboratory ? '기공소명' : '제조사명', dataIndex: 'corpName', align: 'center', },
        { key: 'name', title: '관리자명', dataIndex: 'name', align: 'center', },
        { key: 'username', title: '관리자 ID', dataIndex: 'username', align: 'center', },
        // Assuming 'ip' and 'agent' are properties in your data
        { key: 'ip', title: 'IP', dataIndex: 'ip', align: 'center',
        
          customRender: ({ record }) => {
              if(record.ip) {
                return record.ip;
              } else {
                return '-';
              }
            }
         },
        { key: 'agent', title: '접속 기기', dataIndex: 'agent', align: 'center',
        
          customRender: ({ record }) => {
            if(record.agent) {
              return record.agent;
            } else {
              return '-';
            }
          }
        },
        {
          key: 'lastLoginAt',
          title: '최근 접속 시간',
          dataIndex: 'lastLoginAt',
          align: 'center',
          sorter: (a, b) => dayjs(a.lastLoginAt).unix() - dayjs(b.lastLoginAt).unix(),
          customRender: ({ record }) => this.convertDateTime(record.lastLoginAt)
        },
        {
          key: 'firstLoginAt',
          title: '최초 접속 시간',
          dataIndex: 'firstLoginAt',
          align: 'center',
          sorter: (a, b) => dayjs(a.firstLoginAt).unix() - dayjs(b.firstLoginAt).unix(),
          customRender: ({ record }) => this.convertDateTime(record.firstLoginAt)
        },
        // SPEC-CONTRACT-CENTER-AUTH-001 R6 — 직급/부서/상위부서 컬럼 추가
        { key: 'duty', title: '직급', dataIndex: 'duty', align: 'center',
          customRender: ({ record }) => record.duty || '-'
        },
        { key: 'deptName', title: '부서', dataIndex: 'deptName', align: 'center',
          customRender: ({ record }) => record.deptName || '-'
        },
        { key: 'parentDeptName', title: '상위부서', dataIndex: 'parentDeptName', align: 'center',
          customRender: ({ record }) => record.parentDeptName || '-'
        },
        {
          key: 'manage',
          title: '관리',
          dataIndex: 'manage',
          align: 'center',
          // 지원 서브 계정 행(support 칸)은 배지만 — 수정·초기화·2차 인증 버튼 없음(서버도 403, W6 A6)
          customRender: ({ record }) => isSupportRow(record) ? (
            <span class="support-badge">{supportBadge(record)}</span>
          ) : (
            <div
              style="display: flex; flex-wrap: wrap; gap: 4px 8px; justify-content: center;"
            >
              {supportBadge(record) ? <span class="support-badge">{supportBadge(record)}</span> : null}
              <div
                type="button"
                class="certi-custom-btn"
                onClick={() => this.openMenuManageModal(record.username)}
              >
                메뉴 및 권한 관리
              </div>
              <div
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#resetyesno"
                class="certi-custom-btn"
                onClick={() => this.selectManufacturer(record)}
              >
                비밀번호 초기화
              </div>
              <div
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#logoutyesno"
                class="certi-custom-btn"
                onClick={() => this.selectManufacturer(record)}
              >
                연결해제
              </div>
              <div
                type="button"
                class="certi-custom-btn"
                style="white-space: nowrap"
                onClick={() => {
                  this.securityAccount = record;
                }}
              >
                2차 인증
              </div>
              <div
                type="button"
                class="certi-custom-btn"
                onClick={() => this.openVisibleDeptsModal(record.username, record.companyId)}
              >
                권한 범위 미리보기
              </div>
              {record.isErp !== 'Y' && (
                <div
                  type="button"
                  class="certi-custom-btn"
                  onClick={() => this.editManufacturer(record)}
                >
                  수정
                </div>
              )}
            </div>
          )
        },
      ],
      formEdit: {
        username: "",
        newPassword: "",
        confirmPassword: ""
      },
      editedRecord: {},
      editModalVisible: false,
      editLoading: false,
      // SPEC-CONTRACT-CENTER-AUTH-001 R7 — 권한 범위 미리보기 모달 상태
      visibleDeptsModalVisible: false,
      visibleDeptsLoading: false,
      visibleDeptsData: null,
      visibleDeptsError: null,
    };
  },
  computed: {
    isDentalLaboratory() {
      return this.$route.path.includes('/dental-laboratory');
    },
    type() {
      return this.isDentalLaboratory ? "DENTAL_LABORATORY" : "MANUFACTURER";
    },
    isFormValid() {
      // ID는 필수이고, 비밀번호는 선택사항
      const hasValidUsername = this.formEdit.username && this.formEdit.username.trim() !== '';
      
      // 비밀번호를 입력했다면 유효성 검사
      if (this.formEdit.newPassword) {
        const isPasswordValid = this.validatePassword(this.formEdit.newPassword);
        const doPasswordsMatch = this.formEdit.newPassword === this.formEdit.confirmPassword;
        return hasValidUsername && isPasswordValid && doPasswordsMatch;
      }
      
      // 비밀번호를 입력하지 않았다면 ID만 체크
      return hasValidUsername;
    }
  },
  watch: {
    '$route'(to, from) {
      // 라우트가 변경될 때마다 API 다시 호출
      this.paginationData.currentPage = 1;
      // 검색 조건 초기화
      this.searchFilter = "";
      this.condition = "";
      const obj = {};
      obj.page = this.paginationData.currentPage;
      this.paginationHandler(obj);
    }
  },
  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  methods: {
    validatePassword(password) {
      if (!password) return false;
      
      // 8자 이상
      if (password.length < 8) return false;
      
      // 영문 포함
      if (!/[a-zA-Z]/.test(password)) return false;
      
      // 숫자 포함
      if (!/[0-9]/.test(password)) return false;
      
      // 특수문자 포함
      if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return false;
      
      return true;
    },
    handlePasswordChange() {
      // 비밀번호 입력 시 실시간 유효성 검사
      this.$forceUpdate();
    },
    handleUsernameChange() {
      // 새 관리자 ID가 비어있지 않은 경우에만 에러 제거
      if (this.formEdit.username && this.formEdit.username.trim() !== '') {
        this.$refs.editForm?.clearValidate('username');
      }
    },
    async handleTableChange(pagination, filters, sorter, extra) {
      if(extra.action == "sort" && sorter.order){
        this.sort = {
          parameter:sorter.field,
          method:sorter.order == "ascend"? 'ASC' : sorter.order == "descend"? 'DESC' : '',
        }
      }else if(extra.action == "sort" && !sorter.order){
        this.sort = {
          parameter: 'lastLoginAt',
          method: 'DESC'
        };
      }
      const obj = {};
      obj.page = this.paginationData.currentPage;
      this.paginationHandler(obj);
    },
    async openMenuManageModal(username) {
      this.selectedUser = username;
      this.isModalOpen = true;
    },
    async closeMenuManageModal(value) {
      this.isModalOpen = value;
    },
    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 주요 API
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getManufacturerAccountList();

    },
    // 전체 목록 가져오기
    async getManufacturerAccountList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage; // 페이지네이션 관련 변수
      obj.type = this.type;
      if(this.searchFilter) obj.search = this.searchFilter;
      if(this.condition) obj.condition = this.condition;
      if(this.sort) obj.sort = this.sort;

      try {
        const response = await this.$apiInstance.post(`/accounts/list`, obj);
        if(response.status === 200 || response.status === 201) {
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          this.responseData = response.data.docs;

          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
        }
      } catch(error) {
        console.log(error);
      }
      
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getManufacturerAccountList();
    },
    // 계정 연결해제
    async logoutUser() {
      try {
        // companyId, username
        const obj = {};
        obj.companyId = this.selectedManufacturer.companyId;
        obj.username = this.selectedManufacturer.username;

        const response = await this.$apiInstance.post(`/accounts/target/logout`, obj);
        if(response.status === 200 || response.status === 201) {
        await openDialog("해당 계정이 로그아웃 처리되었습니다.","success", "확인")
        .then(() => {
            location.reload();
          });
      } else {
        await openDialog("로그아웃에 실패하였습니다.", "error", "확인");
      }
      } catch(error) {
        console.log(error);
      }
    },

    // 엑셀 다운로드
    async downloadExcel() {
      const year = new Date().getFullYear();
      const month = String(new Date().getMonth() + 1).padStart(2, "0");
      const day = String(new Date().getDate()).padStart(2, "0");

      const formattedDate = `${year}${month}${day}`;
      try {
        const response = await this.$apiInstance.get(`/accounts/excels/${this.type}`, {
          headers: {
            "Content-Type": "octet-stream"
          },
          responseType: "blob"
        });

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], { type: "application/octet-stream" });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = `${this.isDentalLaboratory ? '기공소' : '제조사'}계정_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
      } catch (error) {
        console.error("Error downloading Excel file:", error);
      }
    },

    async resetPassword() {
      try {
        const response = await this.$apiInstance.put(`/companies/resetPassword/${this.selectedManufacturer._id}`);
        if (response.status === 200 || response.status === 201) {
          await openDialog("비밀번호가 초기화되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        }
      } catch (error) {
        console.log(error);
        await openDialog("비밀번호가 초기화에 실패했습니다.","error", "확인")
      }
    },



    // 기타 ManuAccManage용 utils
    
    // 엔터 눌렀을 때 실행
    async enter() {
      if(this.searchFilter === "") {
        await openDialog("검색 필터를 선택해 주세요.", "error", "확인");
      } else {
        this.paginationData.currentPage = 1;
        await this.getManufacturerAccountList();
      }
    },
    // 날짜, 시간 포맷에 맞추기
    convertDate,

    // 보기, 수정, 삭제 시 선택
    selectManufacturer(manufacturer) {
      this.selectedManufacturer = manufacturer;
    },
    
    editManufacturer(record) {
      console.log('수정할 제조사 계정:', record);
      this.editedRecord = record;
      this.formEdit.username = record.username;
      this.formEdit.newPassword = "";
      this.formEdit.confirmPassword = "";
      this.editModalVisible = true;
    },
    
    async confirmEdit() {
      // 유효성 검사
      if (!this.isFormValid) {
        return;
      }

      // API 호출 전 로딩 시작
      this.editLoading = true;
      
      try {
        // API 파라미터 구성
        const requestBody = {
          newUsername: this.formEdit.username
        };
        
        // 비밀번호가 입력된 경우에만 파라미터에 추가
        if (this.formEdit.newPassword && this.formEdit.newPassword.trim() !== '') {
          requestBody.newPassword = this.formEdit.newPassword;
        }
        
        // 변경사항이 있는지 확인
        const hasUsernameChange = this.formEdit.username !== this.editedRecord.username;
        const hasPasswordChange = this.formEdit.newPassword && this.formEdit.newPassword.trim() !== '';
        
        if (!hasUsernameChange && !hasPasswordChange) {
          this.editLoading = false;
          await openDialog("변경사항이 없습니다.", "warning", "확인");
          return;
        }
        
        // API 호출
        await this.$apiInstance.put(`/accounts/username/${this.editedRecord._id}`, requestBody);
        
        this.editLoading = false;
        this.editModalVisible = false;
        
        // 성공 메시지 구성
        let message = "수정이 완료되었습니다.";
        if (hasUsernameChange && hasPasswordChange) {
          message = "관리자 ID와 비밀번호가 변경되었습니다.";
        } else if (hasUsernameChange) {
          message = "관리자 ID가 변경되었습니다.";
        } else if (hasPasswordChange) {
          message = "비밀번호가 변경되었습니다.";
        }
        
        await openDialog(message, "success", "확인");
        location.reload();
        
      } catch (error) {
        this.editLoading = false;
        console.error(error);
        await openDialog("수정에 실패했습니다.", "error", "확인");
      }
    },
    
    cancelEdit() {
      this.editModalVisible = false;
      this.formEdit.username = "";
      this.formEdit.newPassword = "";
      this.formEdit.confirmPassword = "";
    },

    // SPEC-CONTRACT-CENTER-AUTH-001 R7 — 권한 범위 미리보기 모달
    // @MX:NOTE: [AUTO] 운영자 전용 visible-depts 조회. 비운영자/비인증 호출 시 백엔드에서 403/401 반환.
    // companyId 명시 전달 — cross-company username 중복 시 정확한 행 매칭 보장 (SPEC R7).
    async openVisibleDeptsModal(username, companyId) {
      this.visibleDeptsModalVisible = true;
      this.visibleDeptsLoading = true;
      this.visibleDeptsData = null;
      this.visibleDeptsError = null;

      try {
        const params = companyId ? { companyId } : undefined;
        const response = await this.$apiInstance.get(`/accounts/${username}/visible-depts`, {
          params,
        });
        if (response.status === 200 || response.status === 201) {
          this.visibleDeptsData = response.data;
        }
      } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
          this.visibleDeptsError = '로그인이 필요합니다. 다시 로그인 후 시도해주세요.';
        } else if (status === 403) {
          this.visibleDeptsError = '권한이 없습니다. 운영자 계정으로 접근해주세요.';
        } else {
          this.visibleDeptsError = '권한 범위 조회에 실패했습니다.';
        }
      } finally {
        this.visibleDeptsLoading = false;
      }
    },

    closeVisibleDeptsModal() {
      this.visibleDeptsModalVisible = false;
      this.visibleDeptsData = null;
      this.visibleDeptsError = null;
    },

  },
};
</script>
<style scoped>
/* 지원 서브 계정 행 배지(W6 A6) */
.support-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f0f2f5;
  color: #5c6168;
  font-size: 12px;
  white-space: nowrap;
}
.modal-title {
  font-size: 16px;
  font-weight: bold;
}

.modal-content {
  padding: 20px;
  border: none;
  background: #fff;

  :deep(.ant-form-item) {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
}

.password-section {
  margin-top: 8px;
}

.password-hint {
  margin-top: 8px;
}

.password-error {
  margin-top: 4px;
}

:deep(.ant-modal) {
  padding-bottom: 0;
  
  .ant-modal-body {
    padding: 0;
  }
}
</style>
